import React, { FunctionComponent, ReactNode } from 'react';
import { Provider } from 'react-redux';
import { LoadingSpinner } from '../components/styles/LoadingSpinner';
import { store } from './Store';

type Props = {
  /** Set true to tell the component that initialisation is complete */
  initialized: boolean;
  children: ReactNode;
};

/**
 * Provides the store to its children, ensuring that it is only exposed after initialization completes.
 * Renders a loading spinner while the app is initializing.
 */
export const AppStoreProvider: FunctionComponent<Props> = (props) => {
  return props.initialized ? (
    <Provider store={store}>{props.children}</Provider>
  ) : (
    <LoadingSpinner />
  );
};
